module.exports = __webpack_public_path__ + "img/up14.6822e821.png";